// extracted by mini-css-extract-plugin
export default {"container":"TerritoriesTab_container__S9-xs","content":"TerritoriesTab_content__y+WdS","empty":"TerritoriesTab_empty__m5j2a","list":"TerritoriesTab_list__+qYGC"};